// extracted by mini-css-extract-plugin
export var bold = "_rp-0";